import { EStateMotor } from "@core/enums/stateMotor.enum"

export enum EColor {
	greenOne = 'greenOne',
	greenTwo = 'greenTwo',
	greenThree = 'greenThree',
	greenFour = 'greenFour',
	orangeOne = 'orangeOne',
	orangeTwo = 'orangeTwo',
	redOne = 'redOne',
	redTwo = 'redTwo',
	redThree = 'redThree',
	backgroundOne = 'backgroundOne',
	backgroundTwo = 'backgroundTwo',
	grayOne = 'grayOne',
	grayTwo = 'grayTwo',
}

export enum EFontSize {
	titleOne = 'titleOne',
	titleTwo = 'titleTwo',
	titleThree = 'titleThree',
	headingOne = 'headingOne',
	headingTwo = 'headingTwo',
	headingThree = 'headingThree',
	normal = 'normal',
	small = 'small',
	tiny = 'tiny',
}

export const levelColorMap: Record<string, EColor> = {
	'Nivel A': EColor.greenTwo,
	'Nivel B': EColor.orangeOne,
	'Nivel C': EColor.redThree
}

export const stateColorMap: Record<EStateMotor, EColor> = {
	[EStateMotor.encendido]: EColor.greenOne,
	[EStateMotor.apagado]: EColor.redOne,
	[EStateMotor.offline]: EColor.grayTwo,
	[EStateMotor.esperando]: EColor.orangeOne
}